<template>
  <div>
    <el-row type="flex" justify="space-between" class="mb15">
      <el-col :span="12">
        <strong>模板类型:</strong>
        <el-select
          v-model="ruleForm.url"
          placeholder="请选择"
          @change="handleChange()"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-card>
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        class="menuTable"
        tooltip-effect="dark"
        :data="menuList"
        border
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column
          prop="title"
          label="导航名称"
          min-width="40%"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="enabled"
          label="状态"
          align="center"
          min-width="25%"
        >
          <template slot-scope="scope">
            <el-switch
              v-if="scope.row.foreverExist != 1"
              v-model="scope.row.enabled"
              :active-value="1"
              :inactive-value="-1"
              @change="updateSwitching(scope.row)"
              class="switchStyle"
            ></el-switch>
            <div v-else>展示</div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      ids: [],
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      menuList: [],
      searchForm: {},
      loading: false,
      dialogVisible: false,
      popType: "",
      options: [
        {
          value: "/",
          label: "落户吧网页",
        },
        {
          value: "/cityChannel",
          label: "城市频道网页旧",
        },
        {
          value: "/cityChannelNew",
          label: "城市频道网页新",
        },
        {
          value: "/governmentSubsidies",
          label: "政府补贴网页",
        },
        {
          value: "/bgPromote",
          label: "背景提升网页",
        },
        {
          value: "/settleDetail",
          label: "落户政策详情页网页",
        },
        {
          value: "/settleMore",
          label: "落户政策更多网页",
        },
        {
          value: "/eduSupermarket",
          label: "职教超市网页",
        },
        {
          value: "/settleAttack",
          label: "落户攻略网页",
        },
        {
          value: "/agencyAlliance",
          label: "机构联盟网页",
        },
      ],

      ruleForm: {
        type: 1,
        displayType: 1,
        classificationType: 2,
        linkUrl: "",
        title: "",
        sort: "",
        name: "",
        //    其他接口用的参数
        enabled: 1,
        forever_exist: -1,
        url: "/",
        id: "",
      },
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    },
  },
  methods: {
    pageList() {
      this.api.schoolPage
        .getMenuList({
          url: this.ruleForm.url,
        })
        .then((result) => {
          this.menuList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handleChange() {
      this.pageList();
    },
    updateSwitching(row) {
      this.api.schoolPage
        .menuSwitch({
          id: row.id,
          enabled: row.enabled,
          url: this.ruleForm.url,
        })
        .then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.pageList();
          } else {
            this.$message({
              type: "error",
              message: result.message,
            });
            this.pageList();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  watch: {},
  mounted() {
    this.pageList();
  },
};
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/onlineSchool/menuSetting.vue